import { useCurriculumsStore } from '@vuejs/stores/CurriculumsStore'

/**
 * Return id from url
 *   this is helpful when the curriculumId is
 *   not in the store or access to store is unavailable
 *
 * @example getCurriculumParamsFromUrl()
 * @returns { curriculumId: number | null, curriculumFrequency: number }
 */

export function getCurriculumParamsFromUrl() {
	const curriculumsStore = useCurriculumsStore()
	const pathname = window.location.pathname
	const pathArray = pathname.split('/')
	const curriculumId = pathArray[4] ? Number(pathArray[4]) : null
	const queryString = window.location.search
	const queryParams = new URLSearchParams(queryString)
	const curriculumFrequency = Number(queryParams.get('frequency')) || 1

	curriculumsStore.curriculumFrequency = curriculumFrequency
	curriculumsStore.curriculumId = curriculumId

	return { curriculumFrequency: curriculumFrequency, curriculumId: curriculumId }
}
